import {
  DOCUMENT,
  inject,
  Injectable,
  Renderer2,
  RendererFactory2
} from '@angular/core';

type BodyModifierClass = 'wizard-actions-visible' | 'batch-menu-visible';

@Injectable({
  providedIn: 'root'
})
export class BodyService {
  private document = inject(DOCUMENT);

  private renderer: Renderer2;

  constructor() {
    const rendererFactory = inject(RendererFactory2);

    this.renderer = rendererFactory.createRenderer(null, null);
  }

  private addBodyClass(name: string) {
    this.renderer.addClass(document.body, name);
  }

  private removeBodyClass(name: string) {
    this.renderer.removeClass(document.body, name);
  }

  public setBodyModifierClass(name: BodyModifierClass): void {
    this.addBodyClass(name);
  }

  public unsetBodyModifierClass(name: BodyModifierClass): void {
    this.removeBodyClass(name);
  }
}
